export class FotoWebSettings {
  id?: number;
  clientId?: string;
  clientSecret?: string;
  server?: string;
  isClientSecretSet?: boolean;
  copiedFromAffiliateLevel?: boolean;

  constructor(
    id?: number,
    clientId?: string,
    clientSecret?: string,
    server?: string,
    isClientSecretSet?: boolean,
    copiedFromAffiliateLevel?: boolean,
  ) {
    this.id = id;
    this.clientId = clientId;
    this.clientSecret = clientSecret;
    this.server = server;
    this.isClientSecretSet = isClientSecretSet;
    this.copiedFromAffiliateLevel = copiedFromAffiliateLevel;
  }

  get isConfigured(): boolean {
    return (
      this.clientId != null &&
      this.clientId.trim() != '' &&
      this.isClientSecretSet &&
      this.server != null &&
      this.server.trim() != ''
    );
  }
}
